import React, { useState } from 'react';
import DateSelect from 'src/components/DateSelect/DateSelect';

import AiCommonModal from './AiCommonModal';

interface IProps {
    step: number;
    totalSteps: number;
    onNext: (date: Date) => void;
    onBack: () => void;
    onClose: () => void;
}

const PickupDateCard = ({ step, totalSteps, onNext, onBack, onClose }: IProps) => {
    const [pickupDate, setPickupDate] = useState<Date | null>(null);

    return (
        <AiCommonModal
            title={
                <div className="flex items-center justify-between w-full">
                    <span>When should it be picked up?</span>
                    <span className="text-gray400 text-xs font-normal">
                        {step}/{totalSteps}
                    </span>
                </div>
            }
            agent="kate"
            handleClose={onClose}
            secondaryBtnText="Back"
            secondaryBtnOnClick={onBack}
            primaryBtnText="Next"
            primaryBtnOnClick={() => pickupDate && onNext(pickupDate)}
            primaryBtnDisabled={!pickupDate}
        >
            <p className="text-gray500 text-xs leading-[1.5] font-normal mb-3">Let me know your preferred pickup date so I can find the best available carriers</p>
            <DateSelect
                inputName="pickupDate"
                id="pickupDate"
                placeholder="Select a date"
                dateFormat="EEE, MMMM do, yyyy"
                selected={pickupDate}
                value={pickupDate ? pickupDate.toISOString() : undefined}
                minDate={new Date()}
                onChangeFunc={(e) => setPickupDate(e.value)}
            />
        </AiCommonModal>
    );
};

export default PickupDateCard;
